import { createRouter, createWebHistory } from "vue-router";
import { useAuth } from "@/stores/auth";

// Auth
import RegisterForm from "@/AuthComponents/RegisterForm.vue";
import LoginForm from "@/AuthComponents/LoginForm.vue";
import OIDCCallback from "@/AuthComponents/OIDCCallback.vue";

// Users
import UserList from "@/live-sessions/components/UserComponents/UserList.vue";
import UserDetail from "@/live-sessions/components/UserComponents/UserDetail/UserDetail.vue";
// import UserEvaluation from "@/live-sessions/components/UserComponents/UserEvaluation.vue"; // AKTUELL NICHT VERWENDET
import UserGoals from "@/live-sessions/components/UserComponents/UserGoals.vue";

// Teams
import TeamList from "@/live-sessions/components/TeamComponents/TeamList.vue";
import TeamForm from "@/live-sessions/components/TeamComponents/TeamForm.vue";
import TeamTemplates from "@/live-sessions/components/TeamComponents/TeamTemplates.vue";
import TeamAssignment from "@/live-sessions/components/TeamComponents/TeamAssignment.vue";

// Criterias
import CriteriaList from "@/live-sessions/components/CriteriaComponents/CriteriaList.vue";
import CriteriaForm from "@/live-sessions/components/CriteriaComponents/CriteriaForm.vue";
// import CriterionUserView from "@/live-sessions/components/CriteriaComponents/CriterionUserView.vue"; // AKTUELL NICHT VERWENDET

// AI Feedback
import AIFeedback from "@/live-sessions/components/AIFeedback.vue";

// Prompt Config
import PromptConfig from "@/live-sessions/components/PromptConfig.vue";

// Sessions
import SessionList from "@/live-sessions/components/SessionComponents/SessionList.vue";
import SessionForm from "@/live-sessions/components/SessionComponents/SessionForm.vue";
import SessionEdit from "@/live-sessions/components/SessionComponents/SessionEdit.vue";

// Async Messages
import MessagesList from "../async-sessions/pages/MessagesList.vue";
import PromptVersionsPage from "../async-sessions/pages/PromptVersionsPage.vue";
import ReflectionPage from "../async-sessions/pages/ReflectionPage.vue";
import ProfessorSessionOverview from "@/live-sessions/pages/ProfessorSessionOverview.vue";
import StudentSessionOverview from "@/live-sessions/pages/StudentSessionOverview.vue";

// Admin
import AdminDashboard from "@/AdminComponents/AdminDashboard.vue";

// Roles
import RoleList from "@/live-sessions/components/RoleComponents/RoleList.vue";
import RoleForm from "@/live-sessions/components/RoleComponents/RoleForm.vue";

//Files
import FileExports from "@/live-sessions/components/FileComponents/FileExports.vue";

//LandingPage
import LandingPage from "@/LandingPage.vue";
//Feedback
import UserFeedback from "@/FeedbackComponents/UserFeedback.vue";
import NotificationHelper from "@/HelpComponents/NotificationHelper.vue";

const routes = [
  { path: "/", component: LandingPage, meta: { requiresAuth: true } },
  { path: "/login", component: LoginForm },
  { path: "/register", component: RegisterForm },
  { path: "/auth/callback", component: OIDCCallback },

  // Users
  { path: "/users", component: UserList, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  { path: "/users/:id", component: UserDetail, meta: { requiresAuth: true, allowedTypes: ["professor"], chatRoles: ["professor"] } },
  // { path: "/users/:id/evaluation", component: UserEvaluation, props: true, meta: { requiresAuth: true, allowedTypes: ["professor"] } }, // AKTUELL NICHT VERWENDET
  { path: "/users/:id/goals", component: UserGoals, props: true, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  { path: "/users/:id/feedback", component: UserFeedback, props: true, meta: { requiresAuth: true, allowedTypes: ["student"], chatRoles: ["student"] }
},

  // Teams
  { path: "/teams", component: TeamList, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  { path: "/teams/create", component: TeamForm, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  { path: "/teams/edit/:id", component: TeamForm, props: true, meta: { requiresAuth: true, allowedTypes: ["professor"] } },

  // Criterias
  { path: "/criterias", component: CriteriaList, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  { path: "/criterias/create", component: CriteriaForm, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  { path: "/criterias/edit/:id", component: CriteriaForm, props: true, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  // { path: "/criterias/:id/users", component: CriterionUserView, props: true, meta: { requiresAuth: true, allowedTypes: ["professor"] } }, // AKTUELL NICHT VERWENDET

  // AI Feedback
  { path: "/ai-feedback", component: AIFeedback, meta: { requiresAuth: true, allowedTypes: ["professor"] } },

  // Prompt Configuration
  { path: "/prompt-config", component: PromptConfig, meta: { requiresAuth: true, allowedTypes: ["professor"] } },

  // Sessions
  { path: "/sessions", component: SessionList, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  { path: "/sessions/create", component: SessionForm, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  { path: "/sessions/edit/:id", component: SessionEdit, props: true, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  { path: "/sessions/team-templates", component: TeamTemplates, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  { path: "/sessions/assign-teams", component: TeamAssignment, meta: { requiresAuth: true, allowedTypes: ["professor"] } },

  // Async Messages
  { path: "/async", redirect: "/async/messages" },
  { path: "/async/messages", component: MessagesList, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  { path: "/async/prompt-versions", component: PromptVersionsPage, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  { path: "/async/reflection", component: ReflectionPage, meta: { requiresAuth: true, allowedTypes: ["professor"] } },

  // Session Overview
  { path: "/session-overview", component: ProfessorSessionOverview, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  { path: "/my-session-overview", component: StudentSessionOverview, meta: { requiresAuth: true, allowedTypes: ["student"] } },

  // Admin
  { path: "/admin", component: AdminDashboard, meta: { requiresAuth: true, allowedTypes: ["admin"] } },

  // Roles
  { path: "/roles", component: RoleList, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  { path: "/roles/create", component: RoleForm, meta: { requiresAuth: true, allowedTypes: ["professor"] } },
  { path: "/roles/edit/:id", component: RoleForm, props: true, meta: { requiresAuth: true, allowedTypes: ["professor"] } },

  // Files
  { path: "/files", component: FileExports, meta: { requiresAuth: true, allowedTypes: ["professor", "admin"] } },

  // Notification helper
  { path: "/notifications", component: NotificationHelper, meta: { requiresAuth: true, } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard
router.beforeEach((to, from, next) => {
  const auth = useAuth();

  const loggedIn = auth.isLoggedIn.value;
  const userType = auth.user?.value?.user_type?.toLowerCase() || "";

  if (loggedIn && userType === "unassigned" && to.path !== "/") {
    next("/");
    return;
  }

  if (to.meta.requiresAuth && !loggedIn) {
    next("/login");
  } else if (to.meta.allowedTypes && !to.meta.allowedTypes.map(t => t.toLowerCase()).includes(userType)) {
    next("/");
  } else {
    next();
  }
});

export default router;
